/* eslint-disable @typescript-eslint/member-ordering */
/* eslint-disable @angular-eslint/prefer-on-push-component-change-detection */

import { Component, inject, Injector, runInInjectionContext } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { Timestamp } from '@angular/fire/firestore';
import { FormBuilder, FormGroup } from '@angular/forms';

import {
  PlatformTextProperties,
  PlatformTextPropertiesName,
} from '../../../../../../shared/db-models/media';

@Component({
  selector: 'app-platform-text-properties-form',
  standalone: false, // eslint-disable-line @angular-eslint/prefer-standalone
  templateUrl: './template.html',
})
export class PlatformTextPropertiesFormComponent {
  form: FormGroup;
  properties = Object.values(PlatformTextPropertiesName);
  private injector: Injector;
  private fb: FormBuilder;
  private db: AngularFirestore;

  constructor() {
    this.fb = inject(FormBuilder);
    this.db = inject(AngularFirestore);
    this.injector = inject(Injector);
    this.form = this.fb.group({});

    for (const property of this.properties) {
      this.form.addControl(property, this.fb.control(false));
      this.form.addControl(`${property}-value`, this.fb.control(''));
    }
    // Use compat API within injection context to avoid injection errors
    runInInjectionContext(this.injector, () => {
      this.db
        .doc<PlatformTextProperties>('media/textProperties')
        .valueChanges()
        .subscribe((data) => {
          if (data) {
            for (const property of Object.keys(data)) {
              this.form.controls[property].setValue(data[property].value);
              this.form.controls[`${property}-value`].setValue(data[property].value);
            }
          }
        });
    });
  }
  submit() {
    const data = this.form.value;
    const platformTextProperties = {} as PlatformTextProperties;
    for (const property of this.properties) {
      if (data[property]) {
        platformTextProperties[property] = {
          key: property,
          uploadedAt: Timestamp.now(),
          value: data[`${property}-value`],
        };
      }
    }
    // Use compat API within injection context to avoid injection errors
    runInInjectionContext(this.injector, () => {
      this.db.doc('media/textProperties').set({ ...platformTextProperties });
    });
  }
}
